// extracted by mini-css-extract-plugin
export default {"common__card_body":"card_common__card_body__BYyi+","fullHeight":"card_fullHeight__aHwmt"};